import React from 'react';

const SubscriptionRenew = ({ networkDetail }) => {
  return (
    <>
      <div className="page-headline is-flex">
        <div>
          <strong>Subscription</strong>&nbsp;|&nbsp;Renew
        </div>
      </div>

      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Subscription Expired</h1>
        <p>Your subscription plan does not include this feature. Please upgrade your subscription plan or contact support@sided.co if you feel this is an error.</p>
      </div>
    </>
  );
};

export default SubscriptionRenew;
